import { useState, memo } from 'react';
import { SellMenu } from 'tradera/components/site-header/sell-menu';
import { HOVER_MENUS } from './hover-menu/constants';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { selectIsUnderage } from 'tradera/state/member/selectors';
import { useAppSelector } from 'tradera/state/hooks';
import { UnderageModal } from 'tradera/components/underage/underage-modal';
import { Button } from 'tradera/components/atoms/button/button';
import { classNames } from 'tradera/utils/class-names';

type SellingLinkProps = {
    onClick: (e: React.MouseEvent<HTMLElement>, menu: string) => void;
    mouseOver: (menu: string) => void;
    mouseOut: () => void;
    showMenu: boolean;
};

const SellingLinkMemo = ({
    onClick,
    mouseOver,
    mouseOut,
    showMenu
}: SellingLinkProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const selling = t('siteHeader_selling');
    const isUnderage = useAppSelector(selectIsUnderage);
    const [showUnderageModal, setShowUnderageModal] = useState(false);

    return (
        <>
            {isUnderage && (
                <UnderageModal
                    show={showUnderageModal}
                    onClose={() => setShowUnderageModal(false)}
                />
            )}
            <div
                onMouseEnter={() => mouseOver(HOVER_MENUS.SELL)}
                onMouseLeave={mouseOut}>
                <Button
                    theme="text"
                    href={
                        isUnderage ? undefined : toLocalizedUrl('/my/listings')
                    }
                    rel="nofollow"
                    aria-label={selling}
                    className={classNames('slim-header__button px-1', {
                        active: showMenu
                    })}
                    title={selling}
                    data-ga-category="Top navigation"
                    data-ga-action="Selling menu"
                    data-ga-label="Link - Active listings from NavBar"
                    data-nav-syi
                    onClick={(e) => {
                        isUnderage
                            ? setShowUnderageModal(true)
                            : onClick(e, HOVER_MENUS.SELL);
                    }}>
                    <span
                        className={'slim-header__link-text d-none d-lg-inline'}>
                        {selling}
                    </span>
                </Button>
                {!isUnderage && <SellMenu showMenu={showMenu} />}
            </div>
        </>
    );
};

export const SellingLink = memo(SellingLinkMemo);
